// Special offers constants for SpecialOffers component

export const SWIPER_IMAGES = [
  "/swiper/1.jpg",
  "/swiper/2.jpg",
  "/swiper/3.jpg",
  "/swiper/4.jpg",
  "/swiper/5.jpg",
  "/swiper/6.jpg",

];

export const SPECIAL_OFFERS_TEXT = {
  heading: "Special Offers",
  subheading: "Limited-time flight deals to fuel your next adventure",
  loading: "Loading amazing offers...",
  errorIcon: "⚠️",
  noOffersIcon: "✈️",
  noOffers: "No special offers available right now.",
  noOffersSub: "Check back soon for amazing deals!",
  defaultAirline: "Special Discount",
  limitedTime: "Limited time offer!",
  perTicket: "/ticket",
  youSave: "You save",
}; 